module.exports = __webpack_public_path__ + "img/linea.cd0093e9.svg";